import React from "react";

// Every place a song shows its own small cover image builds it from the
// YouTube video thumbnail - a direct, static URL (img.youtube.com),
// no fetch needed. A Spotify-only song (no youtube_id) had nothing to
// build that from at all, so its avatar/thumbnail just showed broken.
// Falls back to Spotify's own oEmbed thumbnail (no auth needed - same
// no-backend-involvement pattern YouTube's oEmbed already uses for
// autofill, see SongEditPage.jsx) when there's no YouTube id. Unlike
// img.youtube.com, Spotify's oEmbed returns JSON (not a direct image
// URL), so this one needs an actual fetch and its own bit of state.
export const useSongThumbnailUrl = (song) => {
  const youtubeThumbnail = song.youtube_id
    ? `https://img.youtube.com/vi/${song.youtube_id}/0.jpg`
    : null;
  const [spotifyThumbnail, setSpotifyThumbnail] = React.useState(null);

  React.useEffect(() => {
    setSpotifyThumbnail(null);
    if (youtubeThumbnail || !song.spotify_id) return;
    let cancelled = false;
    fetch(
      `https://open.spotify.com/oembed?url=${encodeURIComponent(
        `https://open.spotify.com/track/${song.spotify_id}`
      )}`
    )
      .then((res) => (res.ok ? res.json() : Promise.reject()))
      .then((info) => {
        if (!cancelled) setSpotifyThumbnail(info.thumbnail_url || null);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [song.spotify_id, youtubeThumbnail]);

  return youtubeThumbnail || spotifyThumbnail;
};
